import React, { useState, useEffect } from 'react';
import logo from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { login, auth } from "../../auth";
import { ToastContainer, toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
import { useAuth } from "../../context/auth";
import Loading from "../../shared/components/Loading/Loading";

export default function HomePage3() {
  // Declare uma nova variável de state, a qual chamaremos de "count"
  const { register, handleSubmit } = useForm();
  const { setUser } = useAuth();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    //document.body.style.backgroundColor = "#f6f6f5";
  });

  async function loginWithEmail(data) {
    const loginUser = {
      ...data,
    };
    setLoading(true);
    try {
      let userData = await login(loginUser);
      if (userData) {
        setUser(userData);
        if (userData.role === 'admin') {
          history.push("/admin-panel/Dashboard");
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
        toast.error("Erro ao realizar login!", {
          autoClose: 4000,
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error("Erro ao realizar login!", {
        autoClose: 4000,
      });
      console.log("error", error);
    }
  }

  return (

    <div class="d-md-flex  align-items-center h-100">

      <div class="col-md-5 p-0 bg-white h-md-100 loginarea">
        <div class="col-12 d-md-flex align-items-center p-5  justify-content-center">
          <div>
            <div className="text-center">
              <Link to="/">
                <img
                  className="logo-svelta "
                  src={logo}
                  alt="logo"
                />
              </Link>
            </div>
            <form className="login-form" onSubmit={handleSubmit(loginWithEmail)}>
              <div class="form-group">
                <label className="label-login">Email:</label>
                <input type="email" ref={register()} name="email" class="form-control input-login" placeholder="email@svelta.com.br" />
                <label className="label-login"> Senha:</label>
                <input type="password" ref={register()} class="form-control input-login" name="password" placeholder="*****" />
              </div>
              <button type="submit" class="btn btn-primary input-login button-login col-12" disabled={loading}>
                {loading ? <i className="fa fa-spinner fa-spin" /> : "Login"}
              </button>
            </form>
            <div className="footer-form">
              @2026 SVELTA Todos os direitos reservados
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-7 p-0 bg-svelta h-md-100 d-none d-sm-block">
        <div class="d-md-flex align-items-center h-md-100 p-5 justify-content-center" />
      </div>
      {loading && <Loading overlay />}
      <ToastContainer />
    </div>

  );
}